import React, { Suspense, useContext } from "react";
import { useIdleTimer } from "react-idle-timer";
import { Navigate, Route, Routes } from "react-router-dom";
import PsContext from "../../context";
import SetMobilePassword from "../login/setMobilePassword";

import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import routes from "../routes";
import Footer from "../footer";
import { THEME_VARIANT } from "../../utils";

const loader = () => {
  return (
    <div className="text-center" style={{ marginTop: "calc(30vh)" }}>
      <Spinner animation="border" />
    </div>
  );
};

const Layout = (props) => {
  const context = useContext(PsContext);
  const drawerWidth = 240;
  const onIdle = () => {
    //context.logout(true);
  };

  const idleTimer = useIdleTimer({ onIdle, timeout: 1000 * 60 * 6 });

  useEffect(() => {
    context.loadSettings();
  }, []);

  if (context.logged != "yes") {
    return <Navigate to="/" />;
  } else if (
    (!context.mobilePass || context.mobilePass.length < 1) &&
    context.settingValue("staff_login_type", "") != "with_pass"
  ) {
    return <SetMobilePassword />;
  } else {
    return (
      <div className="">
        <Suspense fallback={loader()}>
          <Routes>
            {routes.map((item, i) => {
              return (
                item.element &&
                context.allowedAccess(item.module, item.action) && (
                  <Route
                    id={i}
                    path={item.path}
                    name={item.name}
                    exact={item.exact || false}
                    element={<item.element />}
                  />
                )
              );
            })}
          </Routes>
        </Suspense>
        <Footer />
      </div>
    );
  }
};
export default Layout;
